import(/* webpackMode: "eager", webpackExports: ["AddToCart"] */ "/home/runner/work/website/website/libs/hub/feature-hub-detail/src/lib/add-to-cart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DetailTabs"] */ "/home/runner/work/website/website/libs/hub/feature-hub-detail/src/lib/detail-tabs.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/website/website/libs/shadcn/ui/src/index.ts");
;
import(/* webpackMode: "eager" */ "/home/runner/work/website/website/libs/shared/ui/src/index.ts");
